import React from 'react';

class APIHandler extends React.Component{
    static URL = "https://smartledsapi.feedboost.de";
    static APIToken = "49991BC21E1CBEA2473779B943C19F8AE360E5E5384D7F7780A43957265EA0A7";
}

export default APIHandler;